import { Box, Typography } from "@mui/material";
import React from "react";
import DentalIcon from "../../../../assets/SVG/dentalIcon";
import MedicalIcon from "../../../../assets/SVG/medicalIcon";
import { LabelInformation } from "../generalInformation";
import Medical from "./medical";

export default function Equipment({
  densityUnitCount,
  pullToothCount,
  restorationToothCount,
  rooterCanalCount,
  imagingEquipmentCount,
  barometerCount,
  glucometerCount,
  examinationSetCount,
  bedCount,
  paravanCount,
  ecgCount,
  revivingBagCount,
  monitoringCount,
  electronicShockCount,
  popEsmirCount,
  wifeExaminationEquipmentCount,
  geneticallyBedCount,
  sonoKidCount,
  samplingEquipmentCount,
  optometryEquip1,
  optometryEquip4,
  optometryEquip2,
  optometryEquip3,
  audiologistEquip1,
  audiologistEquip2,
  audiologistEquip5,
  audiologistEquip3,
  audiologistEquip4,
  imagingEquip3,
  imagingEquip2,
  imagingEquip1,
  laboratoryEquip2,
  laboratoryEquip1,
  laboratoryEquip5,
  laboratoryEquip4,
  laboratoryEquip3,
  mediaEquip3,
  mediaEquip2,
  mediaEquip1,
}) {
  return (
    <Box
      sx={{
        overflow: "auto",
        "::-webkit-scrollbar": {
          display: "none",
        },
      }}
    >
      <Box display={"flex"} width="max-content" gap="20px" px="20px">
        <Box>
          <Typography className="styleSelectedTab">
            تجهیزات دندان پزشکی
          </Typography>
          <LabelInformation
            label="تعداد یونیت ها"
            value={
              densityUnitCount
                ? densityUnitCount === "BELOW_5"
                  ? "1 تا 5 عدد"
                  : densityUnitCount === "BELOW_10"
                  ? "6 تا 10 عدد"
                  : densityUnitCount === "ABOVE_10"
                  ? "بیش از 10 عدد"
                  : densityUnitCount === "BORROWED"
                  ? "قرضی از دیگر گروه ها"
                  : "1 تا 5 عدد"
                : "مقداری ثبت نشده است"
            }
          >
            <DentalIcon />
          </LabelInformation>
          <LabelInformation label="تجهیزات کشیدن" value={pullToothCount}>
            <DentalIcon />
          </LabelInformation>
          <LabelInformation label="تجهیزات ترمیم" value={restorationToothCount}>
            <DentalIcon />
          </LabelInformation>
          <LabelInformation label="تجهیزات عصب کشی" value={rooterCanalCount}>
            <DentalIcon />
          </LabelInformation>
          <LabelInformation
            label="تجهیزات تصویربرداری"
            value={imagingEquipmentCount}
          >
            <DentalIcon />
          </LabelInformation>
        </Box>
        <Medical
          glucometerCount={glucometerCount}
          examinationSetCount={examinationSetCount}
          barometerCount={barometerCount}
          bedCount={bedCount}
          paravanCount={paravanCount}
          ecgCount={ecgCount}
          revivingBagCount={revivingBagCount}
          monitoringCount={monitoringCount}
          electronicShockCount={electronicShockCount}
        />
        <Box>
          <Typography className="styleSelectedTab">
            ست تجهیزات زنان و مامایی
          </Typography>
          <LabelInformation
            label="تجهیزات معاینه زنان"
            value={wifeExaminationEquipmentCount}
          >
            <MedicalIcon color="#9A9A9A" />
          </LabelInformation>
          <LabelInformation label="پاپ اسمیر" value={popEsmirCount}>
            <MedicalIcon color="#9A9A9A" />
          </LabelInformation>
          <LabelInformation label="تخت ژنیکولوژی" value={geneticallyBedCount}>
            <MedicalIcon color="#9A9A9A" />
          </LabelInformation>
          <LabelInformation label="سونوکید" value={sonoKidCount}>
            <MedicalIcon color="#9A9A9A" />
          </LabelInformation>
          <LabelInformation
            label="تجهیزات نمونه برداری"
            value={samplingEquipmentCount}
          >
            <MedicalIcon color="#9A9A9A" />
          </LabelInformation>
        </Box>
        <Box>
          <Typography className="styleSelectedTab">
            ست تجهیزات بینایی سنجی
          </Typography>
          <LabelInformation
            label="تجهیزات غربالگری اولیه"
            value={optometryEquip1}
          >
            <MedicalIcon color="#9A9A9A" />
          </LabelInformation>
          <LabelInformation label="تجهیزات تجویز" value={optometryEquip4}>
            <MedicalIcon color="#9A9A9A" />
          </LabelInformation>
          <LabelInformation label="اتورفرکتومتر" value={optometryEquip2}>
            <MedicalIcon color="#9A9A9A" />
          </LabelInformation>
          <LabelInformation label="اسلیت لمپ" value={optometryEquip3}>
            <MedicalIcon color="#9A9A9A" />
          </LabelInformation>
        </Box>
        <Box>
          <Typography className="styleSelectedTab">
            ست تجهیزات شنوایی سنجی
          </Typography>
          <LabelInformation
            label="تجهیزات اتوسکوپی و معاینه"
            value={audiologistEquip1}
          >
            <MedicalIcon color="#9A9A9A" />
          </LabelInformation>
          <LabelInformation
            label=" ادیتومتری غربالگری"
            value={audiologistEquip2}
          >
            <MedicalIcon color="#9A9A9A" />
          </LabelInformation>
          <LabelInformation label="تیمپانومتری" value={audiologistEquip5}>
            <MedicalIcon color="#9A9A9A" />
          </LabelInformation>
          <LabelInformation label="ساکشن" value={audiologistEquip3}>
            <MedicalIcon color="#9A9A9A" />
          </LabelInformation>
          <LabelInformation
            label="ادیومتری تشخیصی و OAE و ..."
            value={audiologistEquip4}
          >
            <MedicalIcon color="#9A9A9A" />
          </LabelInformation>
        </Box>
        <Box>
          <Typography className="styleSelectedTab">
            ست تجهیزات تصویربرداری
          </Typography>
          <LabelInformation
            label="سونوگرافی و اکوکاردیوگرافی"
            value={imagingEquip3}
          >
            <MedicalIcon color="#9A9A9A" />
          </LabelInformation>
          <LabelInformation label="رادیوگرافی" value={imagingEquip2}>
            <MedicalIcon color="#9A9A9A" />
          </LabelInformation>
          <LabelInformation label="ماموگرافی" value={imagingEquip1}>
            <MedicalIcon color="#9A9A9A" />
          </LabelInformation>
        </Box>
        <Box>
          <Typography className="styleSelectedTab">
            ست تجهیزات آزمایشگاهی
          </Typography>
          <LabelInformation label="UA" value={laboratoryEquip2}>
            <MedicalIcon color="#9A9A9A" />
          </LabelInformation>
          <LabelInformation label="میکروسکوپی" value={laboratoryEquip1}>
            <MedicalIcon color="#9A9A9A" />
          </LabelInformation>
          <LabelInformation label="CBC" value={laboratoryEquip5}>
            <MedicalIcon color="#9A9A9A" />
          </LabelInformation>
          <LabelInformation label="بیوشیمی" value={laboratoryEquip4}>
            <MedicalIcon color="#9A9A9A" />
          </LabelInformation>
          <LabelInformation label="هورمونی" value={laboratoryEquip3}>
            <MedicalIcon color="#9A9A9A" />
          </LabelInformation>
        </Box>
        <Box>
          <Typography className="styleSelectedTab">
            ست تجهیزات رسانه‌ها
          </Typography>
          <LabelInformation label="دوربین عکاسی" value={mediaEquip3}>
            <MedicalIcon color="#9A9A9A" />
          </LabelInformation>
          <LabelInformation label="استودیو" value={mediaEquip2}>
            <MedicalIcon color="#9A9A9A" />
          </LabelInformation>
          <LabelInformation label="میکروفون" value={mediaEquip1}>
            <MedicalIcon color="#9A9A9A" />
          </LabelInformation>
        </Box>
      </Box>
    </Box>
  );
}
